import Lookup from 'src/componentes/select2';

const RacaLookup = ({ ...rest }) => (
  <Lookup labelKey="nome" valueKey="id" url="/RacaLookup" {...rest} />
);

export default RacaLookup;
